// cookie.web.js
// https://www.npmjs.com/package/cookie

import cookie from "cookie";

export default {
  clearAll: async ()=>{
    const _cookies = cookie.parse(document.cookie);
    Object.keys(_cookies).forEach((cookieName)=>{
      document.cookie = `${cookieName}=; expires=-99999; path=/; domain=${window.main.api.cookieDomain}`;
    });
  },
  getAll: async ()=>{
    return cookie.parse(document.cookie);
  },
  set: async (name,value)=>{
    // return cookie.parseSetCookie(`tzo=${(new Date()).getTimezoneOffset()/60}; domain=${"."+window.main.api.cookieDomain.split(".").slice(-2).join(".")}`);
    return cookie.stringifySetCookie({
      name: name,
      value: value,
      domain: ("."+window.main.api.cookieDomain.split(".").slice(-2).join(".")),
      path: "/",
      // expires: Date.now()+3600000, // 1 hour from now -- If commented out, it's treated as a 'session' cookie
      httpOnly: false,
      secure: (window.main.api.cookieDomain.includes("https")),
      sameSite: 'strict',
    });
  },
};
